<template>
  <div>
    <Header />
    <div class="container">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>
      <div class="merchant">
        <h3>Apply Now For Merchant</h3>
        <form action="" @submit.stop.prevent="">
          <span class="pull-right"><strong>Step 2 / 3</strong></span>
          <div class="row justify-content-between">
            <div class="col-lg-6">
              <!-- <label>
                <h3>Owner's Full Name*</h3>
                <input type="text" v-model="owner_name" placeholder="Owner's Full Name"/>
              </label> -->
              <label>
                <h3>Business Email*</h3>
                <input
                  type="email"
                  v-model="business_email"
                  placeholder="ex: businessname@example.com"
                />
              </label>
            </div>
            <div class="col-lg-6">
              <label>
                <h3>Business Phone Number*</h3>
                <input
                  type="text"
                  v-model="business_phone"
                  placeholder="ex: +61########"
                />
              </label>
            </div>
          </div>
          <div class="row justify-content-between">
            <div class="col-lg-6">
              <label>
                <h3>Business Registration Number*</h3>
                <input
                  type="text"
                  v-model="business_registration_number"
                  placeholder="Busiess Registration Number"
                />
              </label>
            </div>
            <div class="col-lg-6">
              <label>
                <h3>GST/VAT/PAN*</h3>
                <input
                  type="text"
                  v-model="gst_vat_pan"
                  placeholder="GST/VAT/PAN Number"
                />
              </label>
            </div>
          </div>
          <div class="row justify-content-between">
            <div class="col-lg-12">
              <label>
                <h3>Business Address*</h3>
                <input
                  type="text"
                  placeholder="Full Address line"
                  v-model="business_address_line"
                />
              </label>
            </div>
            <div class="col-lg-6">
              <input type="text" placeholder="City Name" v-model="city" />
            </div>
            <div class="col-lg-6">
              <select v-model="country" v-if="countries && countries.length > 0">
                <option value="" selected disabled>Select Country</option>
                <option v-for="country in countries" :key="country.id" :value="country.id">
                  {{country.name}}
                </option>
              </select>
            </div>
            <div class="col-lg-6">
              <input type="text" placeholder="State Name" v-model="state" />
            </div>
            <div class="col-lg-6">
              <input type="text" placeholder="Zip Code" v-model="zip_code" />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <router-link :to="{ name: 'Merchant' }">
                <button>
                  <h3>Back</h3>
                </button>
              </router-link>
            </div>
            <div class="col-3">
                <button type="submit" @click="submitApply">
                  <h3>Next</h3>
                </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Call To Action -->
    <section class="call-to-action text-center" id="call-to-action">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <!-- <img src="../../assets/icons/wallet.svg" alt=""> -->
            <h3>Get your Safe Money Wallet today.</h3>
            <router-link :to="{ name: 'app' }">Get Now</router-link>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <SubscribeForm source="Merchant application"></SubscribeForm>
</div>
        </div>
      </div>
    </section>

    <b-toast
      id="error-toast"
      variant="warning"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Required error</strong>
      </div>

      <div v-if="errors.business_email">
        <p>{{ errors.business_email }}</p>
      </div>
      <div v-else-if="errors.business_phone">
        <p>{{ errors.business_phone }}</p>
      </div>
      <div v-else-if="errors.business_registration_number">
        <p>{{ errors.business_registration_number }}</p>
      </div>
      <div v-else-if="errors.gst_vat_pan">
        <p>{{ errors.gst_vat_pan }}</p>
      </div>
      <div v-else-if="errors.business_address_line">
        <p>{{ errors.business_address_line }}</p>
      </div>
      <div v-else-if="errors.country">
        <p>{{ errors.country }}</p>
      </div>
      <div v-else-if="errors.city">
        <p>{{ errors.city }}</p>
      </div>
      <div v-else-if="errors.state">
        <p>{{ errors.state }}</p>
      </div>
      <div v-else-if="errors.zip_code">
        <p>{{ errors.zip_code }}</p>
      </div>
    </b-toast>

    <Footer />
  </div>
</template>
<script>
import Header from "./HeaderNew.vue";
import SubscribeForm from "./SubscribeForm.vue";
import Footer from "./FooterNew.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapActions, mapState } from "vuex";

export default {
  components: { SubscribeForm,
    Footer,
    Header,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      onChangeStateValue: "",
      errors: [],
      merchantFormData: JSON.parse(localStorage.getItem('merchantFormData')),
      business_email: "",
      business_phone: "",
      business_registration_number: "",
      gst_vat_pan: "",
      business_address_line: "",
      country: "",
      city: "",
      state: "",
      zip_code: "",
      ApplyformSubmit: false,
      valid_email:
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      valid_url:
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
      valid_phonoe: /^\+(?:[0-9] ?){6,14}[0-9]$/,
    };
  },
  created() {
    this.listCountries();
  },
  computed: {
    ...mapState(["successmessage", "errormessage", "message", "countries"]),
  },
  methods: {
    ...mapActions(["listCountries"]),
    submitApply(e) {
      e.preventDefault();
      this.ApplyFormSubmit = false;
      this.errors = [];
      if(!this.merchantFormData || this.merchantFormData == null){
        this.$router.replace({
          name: "Merchant",
        });
      }

      if (this.business_email == '') {
        this.errors["business_email"] = "Business email required.";
        this.$bvToast.show("error-toast");
      } else if (!this.valid_email.test(this.business_email)) {
        this.errors["business_email"] = "Invalid business email address.";
        this.$bvToast.show("error-toast");
      } else if (this.business_phone == "") {
        this.errors["business_phone"] = "Business phone number required.";
        this.$bvToast.show("error-toast");
      } else if (!this.valid_phonoe.test(this.business_phone)) {
        this.errors["business_phone"] = "Invalid business phone number.";
        this.$bvToast.show("error-toast");
      } else if (this.business_registration_number == "") {
        this.errors["business_registration_number"] =
          "Business Registration Number is required.";
        this.$bvToast.show("error-toast");
      } else if (this.gst_vat_pan == "") {
        this.errors["gst_vat_pan"] = "GST/VAT/PAN is required.";
        this.$bvToast.show("error-toast");
      } else if (this.business_address_line == "") {
        this.errors["business_address_line"] =
          "Business Address Line is required.";
        this.$bvToast.show("error-toast");
      } else if (this.country == "") {
        this.errors["country"] = "Country is required.";
        this.$bvToast.show("error-toast");
      } else if (this.city == "") {
        this.errors["city"] = "City is required.";
        this.$bvToast.show("error-toast");
      } else if (this.state == "") {
        this.errors["state"] = "State is required.";
        this.$bvToast.show("error-toast");
      } else if (this.zip_code == "") {
        this.errors["zip_code"] = "Zip Code is required.";
        this.$bvToast.show("error-toast");
      } else {
        this.isLoading = true;
        
        this.merchantFormData.business_email = this.business_email;
        this.merchantFormData.business_phone = this.business_phone;
        this.merchantFormData.business_reg_number = this.business_registration_number;
        this.merchantFormData.vatpangstnumber = this.gst_vat_pan;
        this.merchantFormData.business_addressline = this.business_address_line;
        this.merchantFormData.business_address_country = this.country;
        this.merchantFormData.business_address_city = this.city;
        this.merchantFormData.business_address_state = this.state;
        this.merchantFormData.business_address_zipcode = this.zip_code;
        this.merchantFormData.complete_step = 2;

        localStorage.setItem("merchantFormData", JSON.stringify(this.merchantFormData));
        this.$router.replace({
          name: "merchant-agreement",
        });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

    // check local storage is set or not
    if(this.merchantFormData && this.merchantFormData != null){
      this.business_email = this.merchantFormData.business_email;
      this.business_phone = this.merchantFormData.business_phone;
      this.business_registration_number = this.merchantFormData.business_reg_number;
      this.gst_vat_pan = this.merchantFormData.vatpangstnumber;
      this.business_address_line = this.merchantFormData.business_addressline;
      this.country = this.merchantFormData.business_address_country ? this.merchantFormData.business_address_country : "";
      this.city = this.merchantFormData.business_address_city;
      this.state = this.merchantFormData.business_address_state;
      this.zip_code = this.merchantFormData.business_address_zipcode;
    }else{
      this.$router.replace({
        name: "Merchant",
      });
    }

  },
};
</script>
<style lang="scss" scoped>
.merchant {
  padding-block-start: 120px;

  h3 {
    color: #000;
    text-align: center;
    margin-block-end: 20px;
    font-size: 20px;
  }
  form {
    background: #f7f9fa;
    border: 1px solid rgba(0, 0, 0, 0.14);
    padding: 54px 43px;
    margin-bottom: 100px;
    button {
      background: #ed1a3b;
      color: #fff;
      border: none;
      height: 70px;
      width: 100%;
      border-radius: 30px;
      padding-top: 15px;
      padding-left: 30px;
      &:hover {
        background: #c70926;
      }
      h3 {
        color: #fff;
        text-align: left;
        font-size: 24px;
        font-weight: 700;
      }
    }
    input {
      width: 100%;
      font-size: 18px;
      font-family: "Poppins", sans-serif;
      height: 70px;
    }
    select {
      width: 100%;
      font-size: 18px;
      font-family: "Poppins", sans-serif;
      height: 70px;
    }
    label {
      width: 100%;
      h3 {
        text-align: left;
      }
      input {
        width: 100%;
        margin: 0px;
      }
    }
  }
}
</style>